const DEFAULT_PREVIEW_ERROR =
  'Das Dokument konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.';

const getResponseErrorMessage = async (response: Response): Promise<string> => {
  try {
    const responseText = await response.text();
    if (responseText) {
      try {
        const body = JSON.parse(responseText);
        if (typeof body?.detail === 'string' && body.detail.trim() !== '') {
          return body.detail;
        }
      } catch {
        if (responseText.trim().toLowerCase() !== 'false') {
          return responseText;
        }
      }
    }
  } catch {
    // Fall through to the status-specific message.
  }

  if (response.status === 403) {
    return 'Sie haben keine Berechtigung, dieses Dokument zu öffnen.';
  }
  if (response.status === 404) {
    return 'Das angeforderte Dokument wurde nicht gefunden.';
  }

  return DEFAULT_PREVIEW_ERROR;
};

export const fetchPdfPreview = async (
  url: string,
  signal: AbortSignal,
): Promise<string> => {
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
    headers: {
      Accept: 'application/pdf',
    },
    signal,
  });

  const contentType = response.headers.get('content-type')?.toLowerCase() ?? '';
  if (!response.ok || !contentType.includes('application/pdf')) {
    throw new Error(await getResponseErrorMessage(response));
  }

  const data = await response.blob();
  return URL.createObjectURL(data);
};
